import { callPostApi, callDeleteApi, callPutApi, callGetApi } from "./api";


export async function userLogin(data) {
      try {
            const response = await callPostApi({ url: "users/login", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function userLogout() {
      try {
            const response = await callGetApi({ url: "users/logout" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function userForgotPassword(data) {
      try {
            const response = await callPostApi({ url: "users/forgot-password", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getUserLookup(data="false") {
      try {
            const response = await callGetApi({ url: `users/lookup/${data}` });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function userResetPassword(data) {
      try {
            const response = await callPostApi({ url: "users/reset-password", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getProfile() {
      try {
            const response = await callGetApi({ url: "users/profile" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getUserList(data) {
      try {
            const response = await callPostApi({ url: "users/admin", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function updateProfile(data) {
      try {
            const response = await callPutApi({ url: "users", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export const uploadProfile = (data) => callPutApi({ url: "users/upload-profile", body: data });

export async function changePassword(data) {
      try {
            const response = await callPostApi({ url: "users/change-password", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getCountries() {
      try {
            const response = await callGetApi({ url: "utils/countries" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getStates(id) {
      try {
            const response = await callGetApi({ url: "utils/states/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getRoles() {
      try {
            const response = await callPostApi({ url: "roles/list" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function add(data) {
      try {
            const response = await callPostApi({ url: "users", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function update(data) {
      return this.interceptors.PUT('users', data);
}

export async function updateUser(data) {
      try {
            const response = await callPutApi({ url: "users/edit", body: data });
            return response;
      } catch (error) {
            throw error;

      }
}

export async function deleteUser(id) {
      try {
            const response = await callDeleteApi({ url: "users/" + id });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function verifyUsers(data) {
      try {
            const response = await callPostApi({ url: "users/verify", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getTimezones() {
      try {
            const response = await callGetApi({ url: "utils/timezone" });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function getDesigners(data) {
      try {
            const response = await callPostApi({ url: "users/designer-lookup", body: data });
            return response;
      } catch (error) {
            throw error;
      }
}

export async function logoutAllUsers() {
      try {
            const response = await callGetApi({ url: "users/logoutAllUsers" });
            return response;
      } catch (error) {
            throw error;
      }
}
